export default __webpack_public_path__ + "static/media/RobotoMono-Medium.ac6a8def.woff2";